const eventDeclensions = [
  'событие',
  'события',
  'событий',
];

const partnersDeclensions = [
  'партнёр',
  'партнёра',
  'партнёров',
];

const templateDeclensions = [
  'шаблон',
  'шаблона',
  'шаблонов',
];

const teamDeclensions = [
  'сотрудник',
  'сотрудника',
  'сотрудников',
];

const partnersEventsDeclensions = [
  'акция',
  'акции',
  'акций',
];

const promocodesEventsDeclensions = [
  'промокод',
  'промокода',
  'промокодов',
];

export const getEventDeclensionForm = (count, type) => {
  let declensions;
  switch (type) {
    case 'event':
      declensions = eventDeclensions;
      break;
    case 'partners':
      declensions = partnersDeclensions;
      break;
    case 'templates':
      declensions = templateDeclensions;
      break;
    case 'team':
      declensions = teamDeclensions;
      break;
    case 'partners_events':
      declensions = partnersEventsDeclensions;
      break;
    case 'promocodes':
      declensions = promocodesEventsDeclensions;
      break;
  }

  if (!count) return `0 ${declensions[2]}`;

  const lastNumber = +count.toString().slice(-1);
  const lastTwoNumbers = +count.toString().slice(-2);

  if (count === 1 || lastNumber === 1 && lastTwoNumbers !== 11) {
    return `${count} ${declensions[0]}`;
  }
  if (lastNumber > 1 && lastNumber < 5) return `${count} ${declensions[1]}`;

  return `${count} ${declensions[2]}`;
};
